var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 409.6,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 102.4
  })), /*#__PURE__*/React.createElement("rect", {
    y: 102.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 204.8,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 307.2,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M0,512l253.908-250.09c2.789-2.747,2.789-9.074,0-11.821L0,0V512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M102.751,191.042l13.834,41.479l43.723,0.339c3.387,0.026,4.792,4.349,2.067,6.361l-35.174,25.974  l13.189,41.688c1.022,3.23-2.655,5.901-5.411,3.932l-35.572-25.426l-35.572,25.426c-2.756,1.97-6.433-0.702-5.411-3.932  l13.189-41.688l-35.174-25.974c-2.725-2.012-1.32-6.335,2.067-6.361l43.723-0.339l13.834-41.479  C97.134,187.828,101.679,187.828,102.751,191.042z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCu);
export default __webpack_public_path__ + "static/media/CU.983ee4efd006d25393a10fd0f17690a2.svg";
export { ForwardRef as ReactComponent };